import { configureStore } from '@reduxjs/toolkit';
import userReducer from 'features/userSlice';
import auctionFormReducer from 'features/auctionFormSlice';
import commonReducer from 'features/commonSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    auctionForm: auctionFormReducer,
    common: commonReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
